import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { rtes } from './init.js'

export default slot => {
  const form = closest('form', slot)
  const { contentDocument } = one('iframe', form)
  const rte = rtes.get(contentDocument)

  if (rte) {
    const { dataset } = slot
    const { selector, src } = dataset

    if (selector) {
      const img = one(selector, contentDocument)

      if (img && src) {
        img.src = src
      }
    }
  }
}